module.exports = __webpack_public_path__ + "mo/img/board_02.52c8f4ed.png";